<div *ngFor="let q of questions" class="row mb-3">
  <p class="xsmall text-muted mb-1">Student's answer</p>
  <span class="small" [ngClass]="{ 'text-danger': isIncorrect(q) }">{{ getStudentAnswer(q) }}</span>
  <p class="xsmall text-muted mb-1">Correct answer</p>
  <span class="small">{{ getCorrectAnswer(q) }}</span>
</div>
